import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import styles from './SlidingPanel.module.css';

const SlidingPanel = ({
  isOpen,
  onClose,
  title,
  children,
  width = '600px',
  showCloseButton = true,
  className = '',
  headerContent = null,
  footerContent = null
}) => {
  const [isAnimatingOpen, setIsAnimatingOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      // При открытии: небольшой delay для триггера transition после монтирования
      const timer = setTimeout(() => {
        setIsAnimatingOpen(true);
      }, 10);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  const handleClose = () => {
    // Сначала запускаем анимацию закрытия
    setIsAnimatingOpen(false);
    // После завершения transition (0.4s = 400ms) закрываем
    setTimeout(() => {
      onClose();
    }, 400);
  };

  if (!isOpen) return null;

  return (
    <>
      {/* Overlay */}
      <div
        className={`${styles.panelOverlay} ${isAnimatingOpen ? styles.open : ''}`}
        onClick={handleClose}
      />
      
      {/* Panel */}
      <div 
        className={`${styles.slidingPanel} ${isAnimatingOpen ? styles.open : ''} ${className}`}
        style={{ width }}
      >
        <div className={styles.panelHeader}>
          <div className={styles.panelTitle}>
            <span>{title}</span>
          </div>
          <div className={styles.panelHeaderContent}>
            {headerContent}
          </div>
          {showCloseButton && (
            <button
              type="button"
              className={styles.closePanelButton}
              onClick={handleClose}
              aria-label="Закрыть окно"
              title="Закрыть"
            >
              <X size={20} />
            </button>
          )}
        </div>
        
        <div className={styles.panelContent}>
          {children}
        </div>

        {footerContent && (
          <div className={styles.panelFooter}>
            {footerContent}
          </div>
        )}
      </div>
    </>
  );
};

export default SlidingPanel;
